import Banner from "@/components/Banner.tsx";
import PodcastIframe from "@/components/PodcastIframe.tsx";

import jsb from "../../../assets/banners/JSB.png";
import {MetaTags} from "@/hooks/MetaTags.tsx";

const IFRAME_SRC = "https://iframe.iono.fm/c/9357?layout=modern"

export default function SportNewsPage() {
    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Op die Kantlyn"}
                description={"Sportnuus en ontledings"}
                url={"/nuus/op-die-kantlyn"}
            />

            <Banner image={jsb}/>

            <PodcastIframe
                src={IFRAME_SRC}
            />
        </>
    );
}

